/**
 * Account-OrderDetails Queries
 */
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

export const getOrderQuery = gql`
  query GetPrintOrder($orderId: String!) {
    orderQuery: getPrintOrder(orderId: $orderId) {
      id
      shortId: short_id
      charge_id
      netsuit_order_id
      userId: user_id
      primaryOrder: primary_order
      certificationLevel: certification_level
      partialPaid: partial_paid
      deliveredDate: delivered_date
      isDelivered: is_delivered
      referenceNumber: reference_number
      invoicePaymentMethod: invoice_payment_method
      paymentMethod: payment_method
      invoiceTerms: invoice_terms
      invoicePaymentStatus: invoice_payment_status
      pastDue: past_due
      source
      imported
      subsidiaryCountry: subsidiary_country
      shippingFirstName: shipping_address_first_name
      shippingPhone: shipping_address_phone
      shippingLastName: shipping_address_last_name
      shippingStreet: shipping_address_street
      shippingApartment: shipping_address_apartment
      shippingCountry: shipping_address_country
      shippingStateProvince: shipping_address_state_province
      shippingCity: shipping_address_city
      shippingZipCode: shipping_address_zip_code
      billingFirstName: billing_address_first_name
      billingLastName: billing_address_last_name
      billingStreet: billing_address_street
      billingApartment: billing_address_apartment
      billingCountry: billing_address_country
      billingStateProvince: billing_address_state_province
      billingCity: billing_address_city
      billingZipCode: billing_address_zip_code
      shippingTax: shipping_tax
      taxAmount: tax_amount
      invoiceLink: invoice_link
      shippingAmount: shipping_amount
      discount: discount_amount
      coupon: coupon_code
      couponType: coupon_type
      freeShipping: free_shipping
      currency {
        shortName: short_name
      }
      orderDate: created_at
      estimatedDate: estimated_date
      placedAuthor: placed_author {
        firstName: first_name
        lastName: last_name
      }
      netsuite: netsuit_order {
        orderStatus {
          internalId
          orderStatus
          fulfillments {
            packages
          }
        }
      }
      payment: payment_object {
        stripeCharge {
          cardData: source {
            name
            last4
            brand
            expMonth: exp_month
            expYear: exp_year
          }
        }
        paypalCharge {
          id
        }
      }
      cart {
        name
        shortId: short_id
        designShortId: design_id
        productName: product_name
        proCertified: pro_certified
        shortDescription: short_description
        image
        code
        notes
        createdAt: created_at
        unitPrice: unit_price
        proDesignId: prodesign_id
        ticketCode: ticket_id
        ticketShortId: ticket_short_id
        ticketStatus: ticket_status
        ticketLastStatus: ticket_last_status
        testPrintFile: test_print_file
      }
      status
      owner
      total: total_amount
      taxFee: tax
      taxPst: tax_pst
      taxGst: tax_gst
      taxVat: tax_vat
      user
      email
    }
  }
`

export const saveDeliveryMutation = graphql(
  gql`
    mutation saveDeliveryPrintOrder($orderId: String!, $isDeliver: Boolean, $date: String) {
      saveDeliveryPrintOrder(orderId: $orderId, isDeliver: $isDeliver, date: $date) {
        message
      }
    }
  `,
  {
    name: 'saveDeliverDate'
  }
)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/PrintOrderDetails/data.ts